<template>
  <div class="base-dropdown-select">
    <button
      type="button"
      class="base-dropdown-select__button"
      :disabled="disabled"
      @click="toggleDropdown"
      @blur="closeDropdown"
    >
      {{ selectedText }}
      <svg
        class="base-dropdown-select__arrow"
        :class="{ 'base-dropdown-select__arrow--open': isDropdownOpen }"
        xmlns="http://www.w3.org/2000/svg"
        width="12"
        height="8"
        viewBox="0 0 12 8"
        fill="none"
      >
        <path
          d="M1 1L6 6L11 1"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
    <ul v-if="isDropdownOpen" class="base-dropdown-select__dropdown">
      <li
        v-for="option in options"
        :key="option[valueField]"
        class="base-dropdown-select__option"
        :class="{ 'base-dropdown-select__option--selected': option[valueField] == value }"
        @mousedown.prevent="selectOption(option[valueField])"
      >
        {{ option[textField] }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'BaseDropdownSelect',

  props: {
    value: {
      type: [String, Number],
      required: true
    },

    options: {
      type: Array,
      required: true,
      default: () => []
    },

    valueField: {
      type: String,
      default: 'value'
    },

    textField: {
      type: String,
      default: 'text'
    },

    disabled: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Select an option'
    }
  },

  data() {
    return {
      isDropdownOpen: false
    };
  },

  computed: {
    selectedText() {
      const selectedOption = this.options.find((option) => option[this.valueField] == this.value);
      return selectedOption ? selectedOption[this.textField] : this.placeholder;
    }
  },

  methods: {
    toggleDropdown() {
      if (!this.disabled) {
        this.isDropdownOpen = !this.isDropdownOpen;
      }
    },

    closeDropdown() {
      this.isDropdownOpen = false;
    },

    selectOption(value) {
      this.$emit('input', value);
      this.$emit('change', value);
      this.closeDropdown();
    }
  }
};
</script>

<style scoped lang="scss">
.base-dropdown-select {
  position: relative;
  display: inline-block;

  &__button {
    border: none;
    background: transparent;
    box-shadow: none;
    font-size: 14px;
    height: fit-content;
    color: #3c44b1;
    font-weight: 700;
    cursor: pointer;
    padding: 0 20px 0 0;
    outline: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;

    &:hover:not(:disabled) {
      color: #2d3490;
    }

    &:focus {
      outline: none;
      border: none;
      box-shadow: none;
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  &__arrow {
    flex-shrink: 0;
    transition: transform 0.2s ease;

    &--open {
      transform: rotate(180deg);
    }
  }

  &__dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    margin-top: 4px;
    background: white;
    border: 1px solid #d1d2db;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    list-style: none;
    padding: 4px 0;
    min-width: 180px;
    z-index: 1000;
    max-height: 300px;
    overflow-y: auto;
  }

  &__option {
    padding: 8px 16px;
    font-size: 14px;
    color: #2d3436;
    cursor: pointer;
    transition: background-color 0.15s ease;

    &:hover {
      background-color: #f5f6fa;
    }

    &--selected {
      color: #3c44b1;
      font-weight: 600;
      background-color: #f0f1ff;

      &:hover {
        background-color: #e6e8ff;
      }
    }
  }
}
</style>
